import React from 'react';

const Menu = ({mostrarmenu}) => {
	return (
		<div className={`menu-mobile ${mostrarmenu ? 'menu-mobile--show' : ''}`}>
			<div className='menu-mobile__container'>
				<a href='#about' className='menu-mobile__link'>
					Nosotros
				</a>
				<a href='#benefits' className='menu-mobile__link'>
					Beneficios
				</a>
				<a href='#galery' className='menu-mobile__link'>
					Galería
				</a>
				<a href='#products' className='menu-mobile__link'>
					Productos
				</a>
			</div>
		</div>
	);
};

export default Menu;
